export class PageLinkModel {
    id;
    title;
    slug;
    type;
    constructor(id, title, slug) {
        this.id = id;
        this.title = title;
        this.slug = slug;
    }

}